export default __webpack_public_path__ + "static/media/html.c7142895.png";